import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paging',
  templateUrl: './paging.component.html',
  styleUrls: ['./paging.component.scss'],
  standalone: false,
})
export class PagingComponent implements OnInit {
  itemsPerPage: number;
  currentPage: number;

  constructor() {}

  /**
   * Default OnInit
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Return total pages based on total results per items per page
   * @returns total pages count number
   */
  totalPages(resultsCount: number): number {
    const total = resultsCount;
    const perPage = this.itemsPerPage;

    // Return the ceiling of the total pages divided by per page to fix any rounding issues.
    const totalPages = Math.ceil(total / perPage);
    return totalPages;
  }

  /**
   * Read the params object to get the current page number needed for paging the search results
   * @param params -router parameter object that contains the current page number
   */
  setCurrentPage(params?: any): void {
    if (params && !isNaN(params.p)) {
      this.currentPage = params.p;
    } else {
      // Default to current page to 1
      this.currentPage = 1;
    }
  }

  /**
   * Return boolean if incoming page does not match the curren tpage
   * @param page - current selected or incoming page
   */
  hasPageChanged(page: number): boolean {
    return page !== this.currentPage;
  }
}
